/**
 * Language-neutral ids for every static (non-content-driven) page, mapped to
 * its real localized path segment — the static-page counterpart to
 * findByLangAndId's `frontmatter.id` for events/larp-erleben/spenden. Used
 * by ContentRedirect ("/go/:id") so a tales.wtf short link can target
 * these pages too, not just donation projects.
 *
 * Must stay in sync with the route table in App.jsx and with
 * scripts/lib/routes.js's DE/EN path constants (same duplication trade-off
 * already accepted elsewhere in this codebase, e.g. the dashboard's
 * independent status arrays) — there's no shared source both a Vite client
 * bundle and a Node build script can import cleanly.
 */
export const STATIC_PAGES = {
  home: { de: "", en: "" },
  events: { de: "events", en: "events" },
  larp: { de: "larp-erleben", en: "experience-larp" },
  spenden: { de: "spenden", en: "donate" },
  impressum: { de: "impressum", en: "legal-notice" },
  datenschutz: { de: "datenschutz", en: "privacy" },
  agb: { de: "agb", en: "terms" },
  kontakt: { de: "kontakt", en: "contact" },
  newsletter: { de: "newsletter", en: "newsletter" },
  about: { de: "ueber-uns", en: "about" },
  team: { de: "ueber-uns/team", en: "about/team" },
  charter: { de: "ueber-uns/gesellschaftsvertrag", en: "about/charter" },
  history: { de: "ueber-uns/rueckblick", en: "about/history" },
  reports: { de: "ueber-uns/rechenschaftsberichte", en: "about/accountability-reports" },
  conduct: { de: "ueber-uns/verhaltenskodex", en: "about/code-of-conduct" },
  "for-organizers": { de: "ueber-uns/fuer-orgas", en: "about/for-organizers" },
  membership: { de: "unterstuetzen/foerdermitgliedschaft", en: "support/membership" },
  sponsoring: { de: "unterstuetzen/sponsoring", en: "support/sponsoring" },
  volunteer: { de: "unterstuetzen/ehrenamt", en: "support/volunteer" },
  press: { de: "presse", en: "press" },
  info: { de: "infos", en: "info" },
};
